var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 114,
    viewBox: "0 0 113 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.11 22.5859C36.41 24.5859 39.51 20.9859 37.21 18.9859C34.81 16.9859 31.71 20.5859 34.11 22.5859Z",
    fill: "#EAA7B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.809405 33.786C3.10941 35.786 6.2094 32.186 3.9094 30.186C1.60941 28.186 -1.49059 31.786 0.809405 33.786Z",
    fill: "#EAA7B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2098 44.886C30.5098 46.886 33.6098 43.286 31.3098 41.286C29.0098 39.186 25.9098 42.886 28.2098 44.886Z",
    fill: "#EAA7B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5086 25.0859C58.8086 27.0859 61.9086 23.4859 59.6086 21.4859C57.3086 19.4859 54.2086 23.0859 56.5086 25.0859Z",
    fill: "#EAA7B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40886 4.18601C11.7089 6.18601 14.8089 2.58602 12.5089 0.586018C10.1089 -1.41398 7.00886 2.18601 9.40886 4.18601Z",
    fill: "#EAA7B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.61 61.9861C59.91 63.9861 63.01 60.3861 60.71 58.3861C58.31 56.2861 55.21 59.9861 57.61 61.9861Z",
    fill: "#EAA7B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.11 82.4861C27.41 84.4861 30.51 80.8861 28.21 78.8861C25.81 76.8861 22.71 80.4861 25.11 82.4861Z",
    fill: "#EAA7B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3094 99.586C57.6094 101.586 60.7094 97.986 58.4094 95.986C56.1094 93.886 53.0094 97.586 55.3094 99.586Z",
    fill: "#EAA7B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8094 90.386C89.1094 92.386 92.2094 88.786 89.9094 86.786C87.6094 84.786 84.5094 88.386 86.8094 90.386Z",
    fill: "#EAA7B8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.309 80.686C110.609 82.686 113.709 79.086 111.409 77.086C109.109 74.986 106.009 78.686 108.309 80.686Z",
    fill: "#EAA7B8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.11 83.5859C56.41 85.5859 59.51 81.986 57.21 79.986C54.81 77.886 51.71 81.5859 54.11 83.5859Z",
    fill: "#EAA7B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0085 112.586C84.3085 114.586 87.4085 110.986 85.1085 108.986C82.7085 106.986 79.6085 110.586 82.0085 112.586Z",
    fill: "#EAA7B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7098 64.2861C42.0098 66.2861 45.1098 62.6861 42.8098 60.6861C40.5098 58.6861 37.4098 62.2861 39.7098 64.2861Z",
    fill: "#EAA7B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2098 57.4861C86.5098 59.4861 89.6098 55.8861 87.3098 53.8861C85.0098 51.7861 81.9098 55.4861 84.2098 57.4861Z",
    fill: "#EAA7B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7096 102.886C39.0096 104.886 42.1096 101.286 39.8096 99.286C37.4096 97.286 34.3096 100.886 36.7096 102.886Z",
    fill: "#EAA7B8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2098 28.686C78.5098 30.686 81.6098 27.086 79.3098 25.086C77.0098 23.086 73.9098 26.686 76.2098 28.686Z",
    fill: "#EAA7B8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2096 5.986C72.5096 7.986 75.6096 4.38601 73.3096 2.38601C70.9096 0.386006 67.8096 3.986 70.2096 5.986Z",
    fill: "#EAA7B8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 39.586C102.609 41.586 105.709 37.986 103.409 35.986C101.109 33.986 98.0094 37.586 100.309 39.586Z",
    fill: "#EAA7B8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5086 81.7859C72.8086 83.7859 75.9086 80.1859 73.6086 78.1859C71.3086 76.0859 68.2086 79.7859 70.5086 81.7859Z",
    fill: "#EAA7B8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5098 41.9861C48.8098 43.9861 51.9098 40.3861 49.6098 38.3861C47.3098 36.3861 44.1098 39.9861 46.5098 41.9861Z",
    fill: "#EAA7B8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2098 45.5859C68.5098 47.5859 71.6098 43.9859 69.3098 41.9859C67.0098 39.9859 63.9098 43.5859 66.2098 45.5859Z",
    fill: "#EAA7B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots1);
export default __webpack_public_path__ + "static/media/dots-1.203c9fc20761ef6733df5e2d5a73459b.svg";
export { ForwardRef as ReactComponent };